<template>
  <div>
    <b-card
      no-body
      class="mb-1"
    >
      <div class="p-1 d-flex flex-wrap align-items-center filtros">
        <div class="btn-group btn-group-sm">
          <button
            class="btn"
            :class="vista === 'alocacoes' && recorte === 'equipamento' ? 'btn-primary' : 'btn-outline-primary'"
            @click="verAlocacoes('equipamento')"
          >
            Por equipamento
          </button>
          <button
            class="btn"
            :class="vista === 'alocacoes' && recorte === 'equipe' ? 'btn-primary' : 'btn-outline-primary'"
            @click="verAlocacoes('equipe')"
          >
            Por equipe
          </button>
          <button
            class="btn"
            :class="vista === 'historico' ? 'btn-primary' : 'btn-outline-primary'"
            @click="verHistorico"
          >
            Histórico
          </button>
        </div>

        <div
          v-if="vista === 'alocacoes'"
          class="divisor"
        />

        <select
          v-if="vista === 'alocacoes'"
          v-model="situacao"
          class="form-control form-control-sm"
          style="width: auto"
          @change="carregar"
        >
          <option value="open">
            Em uso
          </option>
          <option value="released">
            Devolvidos
          </option>
          <option value="all">
            Todos
          </option>
        </select>

        <button
          class="btn btn-sm btn-outline-secondary"
          :disabled="carregando"
          @click="carregar"
        >
          {{ carregando ? 'Atualizando...' : 'Atualizar' }}
        </button>

        <span class="ml-auto resumo">
          <template v-if="vista === 'historico'">
            <strong>{{ paginacao.total }}</strong> movimenta&ccedil;&otilde;es
          </template>
          <template v-else>
            <strong>{{ alocacoes.length }}</strong> registro(s)
            <template v-if="totalEmUso">
              · <strong>{{ totalEmUso }}</strong> em uso
            </template>
          </template>
        </span>
      </div>
    </b-card>

    <b-card no-body>
      <div
        v-if="carregando"
        class="text-center py-4"
      >
        <b-spinner
          small
          variant="primary"
        />
      </div>

      <div
        v-else-if="vista === 'historico' ? movimentos.length === 0 : alocacoes.length === 0"
        class="text-center text-muted py-4"
      >
        {{ textoVazio }}
      </div>

      <table
        v-else-if="vista === 'historico'"
        class="table table-sm mb-0 lista"
      >
        <thead>
          <tr>
            <th class="col-per">
              Quando
            </th>
            <th class="col-sit">
              Movimento
            </th>
            <th>Equipamento</th>
            <th>Equipe</th>
            <th class="text-right col-qtd">
              Qtd
            </th>
            <th>Respons&aacute;vel</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="m in movimentos"
            :key="m.id"
          >
            <td>{{ curto(m.created_at) }}</td>
            <td>
              <span
                class="selo"
                :class="`selo--${m.kind}`"
              >{{ rotuloMovimento(m.kind) }}</span>
            </td>
            <td>
              {{ m.equipment ? m.equipment.name : '—' }}
              <small
                v-if="m.equipment && m.equipment.measure_value"
                class="text-muted"
              >· {{ m.equipment.measure_value }}</small>
              <small
                v-if="m.total_before !== null"
                class="text-muted d-block"
              >total {{ m.total_before }} → {{ m.total_after }}</small>
            </td>
            <td>{{ m.team ? m.team.name : '—' }}</td>
            <td class="text-right num">
              {{ m.quantity }}
            </td>
            <td>{{ m.user ? m.user.name : 'sistema' }}</td>
          </tr>
        </tbody>
      </table>

      <table
        v-else
        class="table table-sm mb-0 lista"
      >
        <thead>
          <tr>
            <th>{{ recorte === 'equipamento' ? 'Equipamento' : 'Equipe' }}</th>
            <th>{{ recorte === 'equipamento' ? 'Equipe' : 'Equipamento' }}</th>
            <th class="text-right col-qtd">
              Qtd
            </th>
            <th class="col-sit">
              Situação
            </th>
            <th class="col-per">
              Período
            </th>
            <th class="text-right col-acoes" />
          </tr>
        </thead>
        <tbody>
          <template v-for="grupo in grupos">
            <tr
              :key="`g-${grupo.chave}`"
              class="grupo"
            >
              <td colspan="5">
                {{ grupo.rotulo }}
              </td>
              <td class="text-right grupo-resumo">
                {{ grupo.emUso ? `${grupo.emUso} em uso` : `${grupo.linhas.length} registro(s)` }}
              </td>
            </tr>
            <tr
              v-for="a in grupo.linhas"
              :key="a.id"
              :class="{ devolvida: a.released_at }"
            >
              <td>{{ recorte === 'equipamento' ? nomeEquipamento(a) : nomeEquipe(a) }}</td>
              <td>{{ recorte === 'equipamento' ? nomeEquipe(a) : nomeEquipamento(a) }}</td>
              <td class="text-right num">
                {{ a.quantity }}
              </td>
              <td>
                <span :class="a.released_at ? 'selo selo--devolvido' : 'selo selo--uso'">
                  {{ a.released_at ? 'Devolvido' : 'Em uso' }}
                </span>
              </td>
              <td :title="detalheDoPeriodo(a)">
                {{ periodo(a) }}
              </td>
              <td class="text-right">
                <button
                  v-if="!a.released_at"
                  class="btn btn-sm btn-outline-danger"
                  :disabled="devolvendo === a.id"
                  @click="devolver(a)"
                >
                  {{ devolvendo === a.id ? '...' : 'Devolver' }}
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div
        v-if="paginacao.last_page > 1"
        class="d-flex justify-content-end p-1"
      >
        <pagination
          :options="opcoesPaginacao"
          v-model="paginacao.current_page"
          :records="paginacao.total"
          :per-page="paginacao.per_page"
          @paginate="carregar"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import opcoesPaginacao from '@/libs/paginationOptions'
import ApiErrorMixin from '@/mixins/ApiErrorMixin'

export default {
  name: 'EquipmentAllocations',
  components: { Pagination },
  mixins: [ApiErrorMixin],

  data() {
    return {
      alocacoes: [],
      carregando: false,
      devolvendo: null,
      recorte: 'equipamento',
      situacao: 'open',
      vista: 'alocacoes',
      movimentos: [],
      paginacao: {
        current_page: 1, per_page: 20, last_page: 1, total: 0,
      },
    }
  },

  computed: {
    opcoesPaginacao() {
      return opcoesPaginacao
    },

    textoVazio() {
      if (this.vista === 'historico') return 'Nenhuma movimentação registrada.'
      if (this.situacao === 'released') return 'Nenhuma devolução registrada.'

      return 'Nenhum equipamento em uso neste nó.'
    },

    totalEmUso() {
      return this.alocacoes
        .filter(a => !a.released_at)
        .reduce((soma, a) => soma + a.quantity, 0)
    },

    grupos() {
      const mapa = {}

      this.alocacoes.forEach(a => {
        const chave = this.recorte === 'equipamento' ? `e-${a.equipment_id}` : `t-${a.team_id}`
        const rotulo = this.recorte === 'equipamento' ? this.nomeEquipamento(a) : this.nomeEquipe(a)

        if (!mapa[chave]) {
          mapa[chave] = {
            chave, rotulo, emUso: 0, linhas: [],
          }
        }

        if (!a.released_at) mapa[chave].emUso += a.quantity
        mapa[chave].linhas.push(a)
      })

      return Object.values(mapa).sort((x, y) => x.rotulo.localeCompare(y.rotulo))
    },
  },

  mounted() {
    this.carregar()
  },

  methods: {
    verAlocacoes(recorte) {
      this.recorte = recorte

      if (this.vista === 'alocacoes') return

      this.vista = 'alocacoes'
      this.carregar()
    },

    verHistorico() {
      this.vista = 'historico'
      this.paginacao.current_page = 1
      this.carregar()
    },

    aplicarPaginacao(pg) {
      this.paginacao.total = pg.total || 0
      this.paginacao.last_page = pg.last_page || 1
      this.paginacao.current_page = pg.current_page || 1
    },

    rotuloMovimento(kind) {
      return {
        cadastro: 'Cadastro',
        entrada: 'Entrada',
        saida: 'Saída',
        alocacao: 'Alocação',
        devolucao: 'Devolução',
        retencao: 'Retenção',
        recuperacao: 'Recuperação',
      }[kind] || kind
    },

    async carregar() {
      if (this.vista === 'historico') {
        await this.carregarHistorico()
        return
      }

      this.carregando = true
      try {
        const res = await this.$http.get(`${this.$store.state.api}equipment/allocations`, {
          params: {
            situacao: this.situacao,
            page: this.paginacao.current_page,
            per_page: this.paginacao.per_page,
          },
        })
        const pg = res.data.data || {}
        this.alocacoes = pg.data || []
        this.aplicarPaginacao(pg)
      } catch (e) {
        this.alocacoes = []
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível carregar as alocações.'), 'error')
      } finally {
        this.carregando = false
      }
    },

    async carregarHistorico() {
      this.carregando = true
      try {
        const res = await this.$http.get(`${this.$store.state.api}equipment/movements`, {
          params: { page: this.paginacao.current_page, per_page: this.paginacao.per_page },
        })
        const pg = res.data.data || {}
        this.movimentos = pg.data || []
        this.aplicarPaginacao(pg)
      } catch (e) {
        this.movimentos = []
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível carregar o histórico.'), 'error')
      } finally {
        this.carregando = false
      }
    },

    async devolver(a) {
      this.devolvendo = a.id
      try {
        await this.$http.post(`${this.$store.state.api}equipment/allocations/${a.id}/release`)
        this.$message('Sucesso', 'Equipamento devolvido.', 'success')
        this.carregar()
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível devolver.'), 'error')
      } finally {
        this.devolvendo = null
      }
    },

    nomeEquipamento(a) {
      if (!a.equipment) return '—'
      const medida = a.equipment.measure_value
        ? ` · ${a.equipment.measure_value} ${a.equipment.type && a.equipment.type.unit ? a.equipment.type.unit.abbreviation : ''}`
        : ''
      const serie = a.equipment.serial ? ` · ${a.equipment.serial}` : ''

      return `${a.equipment.name}${medida}${serie}`
    },

    nomeEquipe(a) {
      return a.team ? a.team.name : '—'
    },

    periodo(a) {
      const inicio = this.curto(a.allocated_at)
      if (!a.released_at) return `desde ${inicio}`

      const mesmoDia = (a.allocated_at || '').slice(0, 10) === (a.released_at || '').slice(0, 10)
      const fim = mesmoDia ? this.hora(a.released_at) : this.curto(a.released_at)

      return `${inicio} → ${fim}`
    },

    detalheDoPeriodo(a) {
      const quem = a.allocated_by ? ` por ${a.allocated_by.name}` : ''
      const inicio = `Alocado em ${this.dataHora(a.allocated_at)}${quem}`

      if (!a.released_at) return inicio

      const devolveu = a.released_by ? ` por ${a.released_by.name}` : ''
      return `${inicio}\nDevolvido em ${this.dataHora(a.released_at)}${devolveu}`
    },

    curto(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
      })
    },

    hora(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },

    dataHora(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('pt-BR')
    },
  },
}
</script>

<style scoped>
.filtros {
  gap: 10px;
}

.divisor {
  width: 1px;
  height: 22px;
  background: #e4e7ec;
}

.resumo {
  font-size: 12px;
  color: #8592a3;
}

.num {
  font-variant-numeric: tabular-nums;
}

.lista td {
  vertical-align: middle;
}

.col-qtd {
  width: 70px;
}

.col-sit {
  width: 120px;
}

.col-per {
  width: 200px;
}

.col-acoes {
  width: 110px;
}

.selo {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

.selo--uso {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.12);
}

.selo--cadastro {
  color: #7367f0;
  background: rgba(115, 103, 240, 0.12);
}

.selo--entrada {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.12);
}

.selo--saida {
  color: #ff9f43;
  background: rgba(255, 159, 67, 0.14);
}

.selo--alocacao {
  color: #00cfe8;
  background: rgba(0, 207, 232, 0.14);
}

.selo--devolucao {
  color: #8592a3;
  background: rgba(133, 146, 163, 0.14);
}

.selo--retencao {
  color: #ff9f43;
  background: rgba(255, 159, 67, 0.14);
}

.selo--recuperacao {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.12);
}

.dark-layout .selo--devolucao {
  color: #b4b7bd;
  background: rgba(180, 183, 189, 0.16);
}

.selo--devolvido {
  color: #8592a3;
  background: rgba(133, 146, 163, 0.14);
}

.grupo td {
  background: #f6f7fb;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6e6b7b;
  padding-top: 5px;
  padding-bottom: 5px;
}

.grupo-resumo {
  letter-spacing: 0;
  text-transform: none;
  font-weight: 400;
}

.devolvida td {
  color: #a8aab5;
}

/* dark mode */
.dark-layout .divisor {
  background: #3b4253;
}

.dark-layout .resumo {
  color: #b4b7bd;
}

.dark-layout .grupo td {
  background: #232a3d;
  color: #b4b7bd;
}

.dark-layout .devolvida td {
  color: #7a8194;
}

.dark-layout .selo--devolvido {
  color: #b4b7bd;
  background: rgba(180, 183, 189, 0.16);
}
</style>
